import React from 'react';
// import logo from './logo.svg';
import './App.css';
import Header from './components/Header/Header';
import NavBar2 from './components/navBar/NavBar2';
import AboutUs from './components/AboutUs/AboutUs';
import Skills from './components/Skills/Skills';
import Projects from './components/Projects/Projects';
import Recommandations from './components/Recommandations/Recommandations';
import Recommandations1 from './components/Recommandations1/Recommandations1';
import Contact from './components/Contact/Contact';
import Footer from './components/Footer/Footer';

function App() {
  return (
    <div className="App">
      <NavBar2/>
      <Header/>
      <AboutUs/>
      <Skills/>
      <Projects/>
      <Recommandations/>
      <Recommandations1/>
      <Contact/>
      <Footer/>
    </div>
  );
}

export default App;
